import { FC } from "react";
import { Center, Spinner, Stack, Text } from "@chakra-ui/react";

import { PageContentLayout } from "../../../shared/PageContentLayout";
import { useGetSbpTransferBanksQuery } from "../../../../api/sbpTransfer";
import { SbpTransferBanksPageInput } from "./SbpTransferBanksPageInput";
import { SbpTransferBanksPageAmount } from "./SbpTransferBanksPageAmount";
import { SbpTransferBanksPageButton } from "./SbpTransferBanksPageButton";
import { SbpTransferBanksPageBankList } from "./SbpTransferBanksPageBankList";

export const SbpTransferBanksPageContent: FC = () => {
  const { data, isPending, isError } = useGetSbpTransferBanksQuery();

  if (isPending) {
    return (
      <Center flex="1" pb="100px">
        <Spinner />
      </Center>
    );
  }

  if (isError || !Array.isArray(data) || data.length === 0) {
    return (
      <Center flex="1" pb="100px">
        <Text variant="brand" textAlign="center">Не удалось загрузить список банков</Text>
      </Center>
    );
  }

  return (
    <PageContentLayout spacing={2.5} overflow="hidden">
      <SbpTransferBanksPageAmount />

      <Stack spacing={0} flex="1" overflow="hidden" bg="white" borderRadius="16px" p="20px">
        <Text mt="1px" fontSize="12.5px" variant="brand" lineHeight="1">
          Куда перевести
        </Text>

        <SbpTransferBanksPageInput />
        <SbpTransferBanksPageBankList />
      </Stack>

      <SbpTransferBanksPageButton />
    </PageContentLayout>
  );
};
